import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import UiTextField from 'ui-components/ui-text-field/UiTextField';
import classNames from 'classnames';
import { UiSwitch } from 'ui-components';

const InputText = ({
  options,
  keyName,
  onSubFilterChange,
  toggler = 'checkbox',
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(options?.method === 'min' ? options?.max : options?.min);
  }, [options]);

  const onTextFieldChange = (e) => {
    onSubFilterChange({
      keyName,
      min: options?.method === 'min' ? options?.defaultMin : e.target.value,
      max: options?.method === 'max' ? options?.defaultMax : e.target.value,
    });
  };

  const handleTogglerChange = (e) => {
    const { checked } = e.target;
    onSubFilterChange({ keyName, active: checked });
  };

  let togglerComponent = null;
  if (toggler === 'switch') {
    togglerComponent = (
      <UiSwitch
        name={keyName}
        checked={options?.active}
        onChange={(event) => {
          handleTogglerChange(event);
          setValue('');
        }}
      />
    );
  } else if (toggler === 'checkbox') {
    togglerComponent = (
      <UiCheckbox
        name={keyName}
        checked={options?.active}
        onChange={(event) => {
          handleTogglerChange(event);
          setValue('');
        }}
      />
    );
  }

  return (
    <div className='input-text mb-10'>
      <UiFormControlLabel
        className='mr-0'
        label={t(options?.label)}
        control={togglerComponent}
      />
      <div className='flex center mr-13'>
        <div className='title'>
          {options?.method === 'min'
            ? t('filter:lessThan')
            : t('filter:greaterThan')}
        </div>
        <UiTextField
          type='number'
          value={value ?? ''}
          onChange={(e) => onTextFieldChange(e)}
          placeholder='16,000,000'
          disabled={!options?.active}
          InputProps={{
            inputProps: {
              className: classNames(
                'text-center',
                !options?.active ? 'disabled' : ''
              ),
            },
          }}
        />
      </div>
    </div>
  );
};

InputText.propTypes = {
  options: PropTypes.object,
  keyName: PropTypes.string,
  onSubFilterChange: PropTypes.func,
  toggler: PropTypes.string,
};

export default InputText;
